<template>
  <div class="japanese-calendar-modal">
    <div class="row">
      <div class="col-md-12">
        西暦：{{seireki}}
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="input-group wareki">
          <select class="form-control era" v-model="inputs.era" style="width: 50px;">
            <option v-for="era in eras" :value="era.id" :key="era.id">
              {{era.display}}
            </option>
          </select>
          <input type="number" v-model="inputs.year" maxlength="2">
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-12 text-right">
        <a href="#" @click.prevent="close">キャンセル</a>
        <span class="mx-1"></span>
        <button type="button" class="action-button btn btn-rounded btn-primary" :disabled="!seireki" @click="save">
          O K
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useToast } from 'bootstrap-vue-next'

const toast = useToast()

// Props
const props = defineProps({
  modelValue: {
    type: String,
    default: ''
  }
})

// Emits
const emit = defineEmits(['update:modelValue', 'close'])

// Data
const inputs = ref({
  era: null,
  year: null
})

const eras = ref([
  { id: 0, display: '' },
  { id: 1, display: '明治', diff: 1867, max: 45 },
  { id: 2, display: '大正', diff: 1911, max: 15 },
  { id: 3, display: '昭和', diff: 1925, max: 64 },
  { id: 4, display: '平成', diff: 1988, max: 31 },
  { id: 5, display: '令和', diff: 2018, max: 99 }
])

// Computed
const seireki = computed(() => {
  if (!inputs.value.era || inputs.value.year === null) return null

  const selectedEras = eras.value.filter(era => era.id === inputs.value.era)
  if (selectedEras.length < 1 || selectedEras[0].max < inputs.value.year) return null

  return Number(inputs.value.year) + Number(selectedEras[0].diff)
})

// Methods
const showToast = (message, variant = 'success') => {
  toast.show({
    title: variant === 'success' ? '成功' : 'エラー',
    body: message,
    variant,
    delay: 2000
  })
}

const initializeInputs = () => {
  if (!props.modelValue) return
  const year = props.modelValue.split('-', 1)
  if (year.length < 1) return

  inputs.value.era = null
  inputs.value.year = null

  for (let i = 0; i < eras.value.length; i++) {
    const era = eras.value[i]
    if (era.diff < year[0] && year < (era.diff + era.max)) {
      inputs.value.era = era.id
      inputs.value.year = year[0] - era.diff
      break
    }
  }
}

const close = () => {
  emit('close')
}

const save = () => {
  if (!seireki.value) return

  if (props.modelValue) {
    const values = props.modelValue.split('-')
    emit('update:modelValue', seireki.value + '-' + values[1] + '-' + values[2])
  } else {
    emit('update:modelValue', seireki.value + '-01-01')
  }
  showToast('保存しました。')
  close()
}

onMounted(() => {
  initializeInputs()
})
</script>

<style scoped>
.japanese-calendar-modal {
  padding: 1rem;
  background: white;
  border-radius: 8px;
  min-width: 350px;
}

.wareki {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.wareki input[type="number"] {
  width: 80px;
  padding: 0.375rem 0.75rem;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
</style>
